// extracted by mini-css-extract-plugin
export default {"title-section":"VyUs","titleSection":"VyUs","tabs":"oGCu"};